import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
  table_type: string().oneOf(['expired', 'today', 'afterToday', 'empty', 'completed']).required(),
});

/**
 * MySpaceMyTasksRefreshEvent
 *
 * - Evento emitido quando a aba de tarefas do meu espaço precisa ser atualizada.
 * - Isso pode acontecer quando: O card é arquivado, a tarefa é finalizada,
 *    o usuário deixa de ser responsável pela tarefa, a tarefa é excluída
 *    ou ela se torna bloqueada por conta do card voltar a etapa.
 */
export class MySpaceMyTasksRefreshEvent extends CreateCommand(RealtimeEventType.MySpaceMyTasksRefresh, SCHEMA) {}
